import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import BC
    from "../../components/BrailleCharacter";
import { DataContext } from "../../store/DataProvider";
import { useTranslation } from "react-i18next";
import MessageBox from '../../components/MessageBox';

const PracticeTabView = props => {
    const { t } = useTranslation();
    const context = useContext(DataContext)
    const [list, setList] = useState([])
    const [index, setIndex] = useState(0)
    const [currentItem, setCurrentItem] = useState({ dots: [] })
    const [searchedItem, setSearchedItem] = useState({ dots: [] })
    const [answerString, setAnswerString] = useState('')
    const [message, setMessage] = useState('')
    const [messageTitle, setMessageTitle] = useState('')
    const [showMessage, setShowMessage] = useState(false)

    useEffect(() => {
        if (props.category) {
            var List = {};
            switch (props.system) {
                case "full":
                    List = context.state.full.getCharactersByCategory(props.category, true);
                    break;
                case "short":
                    List = context.state.short.getKuerzungenByCategory(props.category);
                    break;
                default:
                    break;
            }
            setList(List)
        }
    }, [context, props])

    useEffect(() => {
        getRandomCharacter()
    }, [list])


    const getRandomCharacter = () => {
        if (Object.keys(list).length > 0) {
            let rand = 0;
            do {
                rand = Math.floor(Math.random() * Object.keys(list).length);
            } while (rand === index)

            var item = list[Object.keys(list)[rand]]
            setIndex(rand)
            if (props.mode === 'btt') {
                setCurrentItem(item)
                setSearchedItem(item)
            } else {
                setCurrentItem({ dots: new Array(item.dots.length).fill(0), title: '', accessibilityString: '' })
                setSearchedItem(item)
            }
        }
    }
    const showSolution = () => {
        if(props.mode === 'btt'){
            setMessage(`Die Korrekte Lösung lautet: ${currentItem.accessibilityString !== '' ? currentItem.accessibilityString : currentItem.title}`)
            setMessageTitle("Hinweis!")
            setShowMessage(true)
            setAnswerString("")
            getRandomCharacter()
        }else{
            var solutionString = 'Die Korrekte Lösung lautet: '
            for(let index in searchedItem.dots){
                solutionString += BC.getDotsByNumber(searchedItem.dots[index], index, props.system === "euro", t, searchedItem.dots.length > 1)
                index < searchedItem.dots.length -1 ? solutionString += ', ' : solutionString += '.'
            }
            setMessage(solutionString)
            setMessageTitle("Hinweis!")
            setShowMessage(true)
            getRandomCharacter()
        }
    }
    const check = () => {
        if (props.mode === 'btt') {
            if (answerString.toUpperCase() === searchedItem.title) {
                setMessage("Das ist korrekt")
                setMessageTitle("Glückwunsch!")
                setShowMessage(true)
                setAnswerString("")
                getRandomCharacter()
            } else {
                setMessage("Das ist leider falsch. Probier es doch noch einmal. answer:" + answerString + ", solution:" + searchedItem.title)
                setMessageTitle("Schade!")
                setShowMessage(true)
            }
        } else {
            var correct_answer = false
            for(let index in searchedItem.dots){
                if(currentItem.dots[index] === searchedItem.dots[index]){
                    correct_answer = true
                }else{
                    correct_answer = false
                }
            }
            if (correct_answer) {
                setMessage("Das ist korrekt")
                setMessageTitle("Glückwunsch!")
                setShowMessage(true)
                setAnswerString("")
                getRandomCharacter()
            } else {
                setMessage("Das ist leider falsch. Probier es doch noch einmal. answer:" + answerString + ", solution:" + searchedItem.title)
                setMessageTitle("Schade!")
                setShowMessage(true)
            }
        }
    }
    const updateCurentItem = (e, index) => {
        var copy = {...currentItem}
        copy.dots[index] = e
        setCurrentItem(copy)
    }
    const renderCharacter = () => {
        let characters = [];
        for (let index in currentItem.dots) {
            if (index > 0) {
                if (currentItem.dots[index] > 0 || props.mode === 'ttb') {
                    characters.push(
                        <BC
                            key={index}
                            character={
                                currentItem.dots.length > 0
                                    ? currentItem.dots[index]
                                    : 0
                            }
                            isReading={props.mode === "btt" ? true : false}
                            isPartOfMultipleCharacter={currentItem.dots.length > 1}
                            isEuroBraille={props.system === "euro"}
                            characterIndex={index}
                            onCharacterChange={(e) => updateCurentItem(e, index)}
                        />
                    );
                }
            } else {
                characters.push(
                    <BC
                        key={index}
                        character={currentItem.dots[0]}
                        isReading={props.mode === "btt" ? true : false}
                        isPartOfMultipleCharacter={currentItem.dots.length > 1}
                        isEuroBraille={props.system === "euro"}
                        characterIndex={index}
                        onCharacterChange={(e) => updateCurentItem(e, index)}
                    />
                );
            }
        }
        return characters;
    }
    const renderSeearchedCharacter = () => {
        var result = [];
        result.push(
            <div>
                Gesuchtes Zeichen: {searchedItem.accessibilityString !== '' ? searchedItem.accessibilityString : searchedItem.title}
            </div>
        )
        return result;
    }
    const renderAnswerTextField = () => {
        var result = [];
        result.push(
            <div>
                <input type="text" value={answerString} onChange={(e) => setAnswerString(e.target.value)}></input>
            </div>
        )
        return result;
    }

    return (
        <div>
            {props.mode === 'ttb' ? renderSeearchedCharacter() : ''}
            <div className='HStack'>
                {renderCharacter()}
            </div>
            {props.mode === 'btt' ? renderAnswerTextField() : ''}

            <div>
                <button className='btn btn-success' onClick={check} aria-label='Überprüfen'>Überprüfen</button>
                <button className='btn btn-primary' onClick={getRandomCharacter} aria-label='Neues Zeichen'>Neues Zeichen</button>
                <button className='btn btn-primary' onClick={showSolution} aria-label='Lösung anzeigen'>Lösung anzeigen</button>
            </div>
            <div>
            </div>
            <MessageBox
                key={'infoMessage'}

                show={showMessage}
                title={messageTitle}
                message={message}
                okTitle='OK'
                okAction={() => setShowMessage(false)}
                onHide={() => setShowMessage(false)}
            />
        </div>

    )
}
export default PracticeTabView